import React from "react";

//Dark mode
import useDarkMode from "./hooks/use-dark-mode";
import Toggle from "./components/Toggle";

//Hamburger Menu
import HamburgerMenu from "./components/HamburgerMenu";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { Link } from "react-router-dom";
import { Link, Routes, Route } from "react-router-dom";

//css
// import "./css/App.css";
import "./css/index.css";
import "./css/styles.scss";

//Content
import MainPage from "./components/Pages/MainPage";

//other content pages
import Portfolio1 from "./components/Pages/Portfolio1";
import Portfolio2 from "./components/Pages/Portfolio2";
import Mainpage from "./components/Pages/MainPage";

function App() {
  const [darkMode, setDarkMode] = useDarkMode();

  return (
    <div>
      <div className="navbar">
        <Toggle darkMode={darkMode} setDarkMode={setDarkMode} />
      </div>
      <HamburgerMenu />

      <Routes>
        <Route path="/" element={<MainPage />}></Route>
        <Route path="/home" element={<MainPage />}></Route>
        <Route path="/portfolio1" element={<Portfolio1 />}></Route>
        <Route path="/portfolio2" element={<Portfolio2 />}></Route>
      </Routes>
    </div>
  );
}
export default App;
